export default __webpack_public_path__ + "static/media/Family.ac776088.png";